<script>
import AgreementComponent  from './agreement.component.vue';
export default {
  components: {
    AgreementComponent
  },
  props: {
    module: Object,
  },
  data: () => ({
  }),
  computed: {
  },

  methods: {
  },
};
</script>
<template>
  <div class="card-agreement">
    <CardTitle>
      Путевки:
    </CardTitle>
    <div v-if="module" class="p-t-c-ii" >
      <div>
        <AgreementComponent  v-for="(agreement, j) in module.agreements" :key="agreement.id" :item="agreement"/>
      </div>
    </div>
  </div>
</template>
<style lang="scss">

</style>
